import { MaterialIcon } from "@website/icons/material";
import { AccordionPropertiesType } from "@website/ui/accordion/accordion.types";
import { MouseEvent, useCallback, useState } from "react";

export const useAccordionItem = (properties: AccordionPropertiesType) => {
  const {
    disabled,
    initialExpanded,
    EndIcon,
    EndIconExpanded,
    endText,
    endTextExpanded
  } = properties;
  const [expanded, setExpanded] = useState<boolean>(initialExpanded ?? false);

  const onDetailsClick = useCallback(
    (event: MouseEvent<HTMLDetailsElement>) => {
      event.preventDefault();

      if (!disabled) {
        setExpanded((state) => !state);
      }
    },
    [disabled]
  );

  return {
    detailsProperties: {
      open: expanded
    },
    summeryProperties: {
      onClick: onDetailsClick
    },
    buttonProperties: {
      "aria-label": expanded ? "collapse" : "expand",
      disabled: disabled,
      color: "secondary" as const,
      variant: "text" as const,
      equalDimension: !endText,
      EndIcon: expanded
        ? endText
          ? undefined
          : EndIconExpanded || (
              <MaterialIcon name="keyboard_arrow_up" variant="outlined" />
            )
        : endTextExpanded
          ? undefined
          : EndIcon || (
              <MaterialIcon name="keyboard_arrow_down" variant="outlined" />
            )
    },
    buttonText: expanded ? endTextExpanded || "" : endText || ""
  };
};
